module.exports = __webpack_public_path__ + "static/media/Wix5.8921850c.jpg";